import dropdownMenu from '../../../shared/dropdownMenu'

export default function(namespace) {
  dropdownMenu();
};
